import {apiSlice} from './apiSlice';
import {
    AddLocationParams,
    AllLocations,
    AllLocationsParams,
    EditLocationParams,
    Location
} from '../../types/locationTypes';

export const locationInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllLocations: builder.query<AllLocations, AllLocationsParams>({
            query: ({page = 1, perPage = 999, sort = 'name'}) => `/locations/?page=${page}&per_page=${perPage}&sort=${sort}`,
            providesTags: ['Location'],
        }),
        getSingleLocation: builder.query<Location, number>({
            query: (id): string => `/locations/${id}`,
            providesTags: ['Location'],
        }),
        addLocation: builder.mutation<number, AddLocationParams>({
            query: ({name, description, latitude, longitude, public_note, private_note}) => ({
                url: `/locations/`,
                method: 'POST',
                body: {
                    name,
                    description,
                    longitude,
                    latitude,
                    public_note,
                    private_note,
                }
            }),
            invalidatesTags: ['Location'],
        }),
        updateLocation: builder.mutation<void, EditLocationParams>({
            query: ({locationID, name = '', description = '', latitude, longitude, public_note, private_note}) => ({
                url: `/locations/${locationID}`,
                method: 'PUT',
                body: {
                    name,
                    description,
                    longitude,
                    latitude,
                    public_note,
                    private_note,
                }
            }),
            invalidatesTags: ['Location'],
        })
    })
});

export const locationEndpoints = locationInjectedEndpoints.endpoints;
export const {
    useGetSingleLocationQuery,
    useGetAllLocationsQuery,
    useAddLocationMutation,
    useUpdateLocationMutation,
} = locationInjectedEndpoints;
